import * as React from 'react';
import MatrixTable from './MatrixTable/MatrixTable'
import DefaultUnhandledDropDown from './Components/DefaultUnhandledDropDown'


import './MatrixView.scss'
import { NavBar } from '../../../Models/NavBar/NavBar.Model';

import { QuestsModel, WorkflowsJourney } from '../../../Models/Quests/Quests.Model';
import { MatrixQuestInterface, InheritanceStatus, MatrixInterface, Slug } from '@swivl-mono/types';
import { warn } from '@swivl-mono/helpers';




const data = [
  [{type:"spacer", right:"Color", bottom:"Size"}, {type:"value", variable:"c", axis:"x", values:["SPECIAL_NOT_SET"]}, {type:"value", variable:"c", axis:"x", values:["black", "navy","purple", "pink"]}, {type:"value", variable:"c", axis:"x", values:["green"]} ],
  [{type:"value", variable:"s", axis:"y", values:["small"]}, {type:"quest", quest:"7DADjyqfMq"}, {type:"quest", quest:"7DADjyqfMq"}, {type:"quest", quest:"PAzkF5LEK3"} ],
  [{type:"value", variable:"s", axis:"y", values:["medium", "large"]}, {type:"quest", quest:"PAzkF5LEK3"}, {type:"quest", quest:"7DADjyqfMq"}, {type:"quest", quest:"7DADjyqfMq"}  ],
  [{type:"value", variable:"s", axis:"y", values:["SPECIAL_OTHER"]}, {type:"quest", quest:"PAzkF5LEK3"}, {type:"quest", quest:"7DADjyqfMq"}, {type:"quest", quest:"7DADjyqfMq"}  ],
]

/*
Nodes property will have an object like so:
{
xVariables: ["Color"],
yVariables:["Size"],
defaultUnhandled:"Quest Id",
data: [[array]]
}
 */

interface Props {
  matrix:MatrixQuestInterface
  workflows: WorkflowsJourney[], 
  canEdit:boolean
}

export default class MatrixView extends React.Component<Props> {
  constructor(props:Props) {
    super(props)
    this.state = {xVariables:["Color"], yVariables:["Size"], data:data}
    this.updateHeader           = this.updateHeader.bind(this)
    this.setMatrix              = this.setMatrix.bind(this)
    this.setQuest               = this.setQuest.bind(this)
    this.addColumnOrRow         = this.addColumnOrRow.bind(this)
    this.valueChanged           = this.valueChanged.bind(this)
    this.deleteValue            = this.deleteValue.bind(this)
    this.addValue               = this.addValue.bind(this)
    this.deleteColumnOrRow      = this.deleteColumnOrRow.bind(this)
    this.setVariableForAxis     = this.setVariableForAxis.bind(this)
    this.setDefaultUnhandled    = this.setDefaultUnhandled.bind(this)

  }


    componentWillMount() {
      this.updateHeader()
   

    }
    updateHeader() {
      

      NavBar.set(
        <NavBar.Component.Back />,
        <NavBar.Component.Title>{this.props.matrix.name}</NavBar.Component.Title>,
        <DefaultUnhandledDropDown
          matrix={this.props.matrix}
          workflows={this.props.workflows}
          setDefaultUnhandled={this.setDefaultUnhandled}
          questsModel={QuestsModel}
          enabled={this.props.matrix && this.props.matrix.inheritance !== InheritanceStatus.IS_PARENT }
          />,
          this.props.matrix.name

        );
    }

    // componentDidUpdate(prevProps, prevState, snapshot) {
    //   if (prevProps.quest.get("matrix").defaultUnhandled != this.props.matrix.get("matrix").defaultUnhandled ) {
    //
    //   }
    // }



  setMatrix(matrix:MatrixInterface, shouldSave:boolean) {
    var quest = this.props.matrix;
    quest.data = matrix;
    return QuestsModel.updateQuest(quest, shouldSave) .catch((e) => { warn("Error", e); alert("There was an error saving your matrix") })
    
  }

  /* DELEGATE METHODS */
  setQuest(questSlug, x,y) {
    var matrix = this.props.matrix.data

    if (matrix.data[y][x].type !== "quest" ) { warn("Not a quest!");  return; }
    matrix.data[y][x].quest = questSlug;
    this.setMatrix(matrix, true);
  }

  addColumnOrRow(direction) {
    var matrix = this.props.matrix.data;



    if (direction === "column") {
      for (var i = 0; i < matrix.data.length; i++) {
        if (i < matrix.xVariables.length) {
          matrix.data[i].push({type:"value", variable:matrix.xVariables[i], axis:"x", values:["Value"]})
        } else  {
          matrix.data[i].push({type:"quest", quest:""})
        }
      }
    }
    if (direction === "row") {
      var newRow:any = [];
      for (var i = 0; i < matrix.data[0].length; i++) {
        if (i < matrix.yVariables.length) {
          newRow.push({type:"value", variable:matrix.yVariables[i], axis:"x", values:["Value"]})
        } else  {
          newRow.push({type:"quest", quest:""})
        }
      }
      matrix.data.push(newRow)
    }

    this.setMatrix(matrix, true);
  }

  valueChanged(value, x, y, index, shouldSave) {
    var matrix:any = this.props.matrix.data;
    matrix.data[y][x].values[index] = value;
    this.setMatrix(matrix, shouldSave);
  }

  deleteValue(x, y, index) {
    var matrix:any = this.props.matrix.data;
    matrix.data[y][x].values.splice(index,1)
    this.setMatrix(matrix, true);
  }

  addValue(value, x,y) {
    var matrix:any = this.props.matrix.data;

    matrix.data[y][x].values.push(value);
    this.setMatrix(matrix, true);

  }

  deleteColumnOrRow(columnOrRow, index) {
    var matrix = this.props.matrix.data;
    if (columnOrRow  === "row") {
      matrix.data.splice(index,1)
    } else {
      for (var i = 0; i < matrix.data.length; i++) {
        matrix.data[i].splice(index,1)
      }
    }
    this.setMatrix(matrix, true);
  }
  setVariableForAxis(variableId, side, x, y) {
    var matrix = this.props.matrix.data;

    if  (side === "right")  {
      matrix.xVariables[y] = variableId;
      for (var i = 0; i < matrix.data[y].length; i++) {
        if (matrix.data[y][i].type === "spacer") { matrix.data[y][i].right = variableId; }
        if (matrix.data[y][i].type === "value")  { matrix.data[y][i].variable = variableId; }
      }

    } else  if (side === "bottom") {
      matrix.yVariables[x] = variableId;

      for (var i = 0; i < matrix.data.length; i++) {
        if (matrix.data[i][x].type === "spacer") { matrix.data[i][x].bottom = variableId; }
        if (matrix.data[i][x].type === "value")  {


          matrix.data[i][x].variable = variableId; }
      }
    }

    this.setMatrix(matrix, true);

  }

  async setDefaultUnhandled(questSlug:Slug) {
  
    let matrix = this.props.matrix.data

    matrix.defaultUnhandled = questSlug;
    await this.setMatrix(matrix, true);
    
    this.updateHeader()
  }

  canEdit() {
    return this.props.canEdit;
  }

    render() {

      


      const matrix = this.props.matrix;

      //  We will want to do some massaging here, dynamically adding the add cells and the empty cells me thinks.
      var data = JSON.parse(JSON.stringify(matrix.data.data))
      for (var y = 0; y < data.length; y++) {
        //   if (y === 0) { data[i].push({type:"add" ,  direction:"column"})
        // } else{
        const item = (y === 0) ? {type:"add" ,  direction:"column"}: {type:"empty" }
           data[y].push(item);
        // }
      }
      const bottomRowLength  = data[0].length;
      let bottomRow:any = [{type:"add" ,  direction:"row"}];
      for (var i = 0; i < bottomRowLength - 1; i++) {
        bottomRow.push({type:"empty" });
      }

      data.push(bottomRow);


        return (
            <div className="MatrixView">
            <MatrixTable
              data={data}
              matrix={matrix}
              workflows={this.props.workflows}

              
              delegate={this} 
              canEdit={this.props.canEdit}
      
                         />
              </div>
        );
     }

};
